import React from "react";

import Link from "common-components/StyledLink";
import Modal from "common-components/Modal";

const GuestDeleteFileSuccess = () => (
  <Modal closeModal={() => (window.location.href = "/privacy/your-data")}>
    <h2 style={{ maxWidth: "390px", marginBottom: "60px" }}>We've successfully deleted your file.</h2>
    <Link linkType="anchor" href="/privacy/your-data">
      Close
    </Link>
  </Modal>
);

export default GuestDeleteFileSuccess;
